import { useState, useEffect, useRef } from "react";
import { Box, Typography, TextField } from "@mui/material";
import { UseInstallmentOrderReport } from "./UseInstallmentOrderReport";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import YearMonthOverview from "./YearMonthOverview";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function InstallmentOrderReport(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const { myPc, updatePage, updateSort, setScrollTo, refresh, goToFirstPage } =
    UseMyPC();
  const { GetInstallmentOrderDetail, GetInstallmentOrderReport } =
    UseInstallmentOrderReport();
  const [allReportRes, setAllReportRes] = useState();
  const [reportRes, setReportRes] = useState([]);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();
  const searchRef = useRef("");
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const { toSolar } = require("jdate-convert");
  const today = toSolar(new Date().toJSON().slice(0, 10));
  const [state, setState] = useState({
    year: today ? Number(today.slice(0, 4)) : "",
    month: today ? Number(today.slice(5, 7)) : "",
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (state.year && state.month) {
      setProgress(true);
      GetInstallmentOrderReport(state.year, state.month, (callback) => {
        setAllReportRes(callback);
      });
      GetInstallmentOrderDetail(
        myPc,
        search,
        state.year,
        state.month,
        (callback) => {
          setReportRes(callback);
        },
        true
      );
    } else {
      setReportRes([]);
      setAllReportRes();
    }
  }, [myPc, state]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    // {
    //   field: "rowIndex",
    //   width: 80,
    //   align: "center",
    //   headerName: "ردیف",
    //   headerAlign: "center",
    // },
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "سفارش",
      headerAlign: "center",
    },

    {
      field: "fullName",
      headerName: "نام",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: " موبایل",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "phone",
      headerName: " تلفن",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "city",
      headerName: " شهر",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.city}
          </Typography>
        );
      },
    },
    {
      field: "shamsiLogDate",
      headerName: "تاریخ",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiLogDate}
          </Typography>
        );
      },
    },
    {
      field: "totalPayment",
      headerName: "مجموع خرید",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.totalPayment
              ? toMoney(cellValues.row.totalPayment)
              : 0}
          </Typography>
        );
      },
    },

    {
      field: "state",
      headerName: "وضعیت",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", textAlign: "center" }}
          >
            {cellValues.row.state}
          </Typography>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            fullWidth
            defaultValue=""
            onInput={(e) => {
              if (e.target.value == "") {
                handleSearch("");
              }
              searchRef.current = e.target.value;
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(searchRef.current);
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/installmentreports" }],
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <YearMonthOverview setState={setState} state={state} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              width: "60%",
              justifyContent: "flex-end",
            }}
          >
            <TextField
              fullWidth
              id="outlined-basic"
              label="تعداد سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                width: "35%",
                input: {
                  direction: "rtl",
                  color: "secondary.main",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={allReportRes ? toMoney(allReportRes.orderCount) : ""}
              variant="filled"
            />
            <TextField
              fullWidth
              id="outlined-basic"
              label="مجموع سفارشات"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                width: "50%",
                input: {
                  direction: "rtl",
                  color: "secondary.main",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
              value={allReportRes ? toMoney(allReportRes.totalPayments) : ""}
              variant="filled"
            />
          </Box>
        </Box>
        <Box
          sx={{
            flexGrow: 1,
          }}
        >
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={
              reportRes && reportRes.pageCondition
                ? reportRes.pageCondition.pageCount
                : 1
            }
            rows={reportRes && reportRes.items ? reportRes.items : []}
            paginationMode="server"
            page={
              reportRes && reportRes.pageCondition
                ? reportRes.pageCondition.page - 1
                : 1
            }
            onPageChange={(page) => {
              updatePage(page + 1);
            }}
            rowCount={
              reportRes && reportRes.pageCondition
                ? reportRes.pageCondition.totalItemCount
                : 1
            }
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                scrollTo: myPc.scrollTo,
                isLtr: true,
                nofab: true,
                rowCount:
                  reportRes && reportRes.pageCondition
                    ? reportRes.pageCondition.totalItemCount
                    : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: deCapitalizeFirstLetter(myPc.sortColumn),
                    sort: deCapitalizeFirstLetter(myPc.sortOrder),
                  },
                ],
              },
              pagination: {
                page: myPc.page,
              },
            }}
            onSortModelChange={(model) => {
              updateSort(
                model[0].field,
                model[0].sort == "asc" ? "asc" : "desc"
              );
            }}
            sortingOrder={["desc", "asc"]}
            sortingMode="server"
          />
        </Box>
      </Box>
    </Detail>
  );
}
